<template>
  <import-charge-tab lob="RE" />
</template>

<script>
import importChargeTab from '@/components/Cargo/Job/importCharge/importChargeTab'

export default {
  name: 'ImportChargeRE',
  components: { importChargeTab }
}
</script>
